<template>
    <v-btn
        rounded
        depressed
        color="#E0E1E6"
        :class="['students3d-filter-trigger', { 'advanced-filter-btn-active': active }]"
        style="border: 1px solid #7E8494;"
        :style="active ? cssVars : {}"
        :data-test="dataTest"
        @click="$emit('click')"
    >
        {{ label }}
    </v-btn>
</template>

<script>
export default {
    name: 'AdvancedFilterBtn',
    props: {
        label: {
            type: String,
            required: true,
        },
        dataTest: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        cssVars() {
            const theme = this.$vuetify?.theme?.themes?.light?.primary
            if (!theme) return {}
            return {
                '--primary-color': theme.base,
                '--primary-color-dark': theme.darken1,
                '--primary-color-light2': theme.lighten2,
            }
        },
    },
}
</script>
